<form #addForm="ngForm" >

<div class="row" *ngIf="compositionId==undefined && saveMode==false">
    <div  class="form-group col-12 col-md-3">
        <label for="">Choisir la classe</label>
        <select class="mx-1 form-control" (change)="loadCourses($event)" >
            <option selected disabled></option>
            <option *ngFor="let pacc of paccs" [value]="pacc?.id">{{pacc?.classroom?.name}}</option>
        </select>
    </div>
    <div class="form-group col-12 col-md-3">
        <label for="">Choisir la matière</label>
        <select class="mx-1 form-control" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let c of courses" [value]="c?.id">{{c?.name}}</option>
        </select>
    </div>
    <div class="form-group col-12 col-md-3" >
        <label for="">Choisir la période</label>
        <select class="mx-1 form-control" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
    </div>
 
    <div class="form-group col-12 col-md-3">
        <label for="">Choisir la composition</label>
        <select class="mx-1 form-control" [(ngModel)]="composition_id" name="composition_id" >
            <option selected disabled></option>
            <option *ngFor="let c of compositions" [value]="c?.id">{{c?.name}}</option>
        </select>
    </div>
</div>

<div class="" *ngIf="saveMode">
    <div class="text-center">
        <!-- <button (click)="add(addContent)" class="btn g-bg-danger text-white">Enregister un devoir</button> -->
    </div>
    <div class="row">
        <div class="col-12 col-md-6">
            <dl>
                <dt>Libellé</dt>
                <dd>{{compositionData?.name}}</dd>
            </dl>
            
            <dl>
                <dt>Type</dt>
                <dd>{{compositionData?.type}}</dd>
            </dl>
            <dl>
                <dt>Période</dt>
                <dd>{{compositionData?.period?.name}}</dd>
            </dl>
        </div>
        <div class="col-12 col-md-6">
            <dl>
                <dt>Classe</dt>
                <dd>{{compositionData?.pacc?.classroom?.name}}</dd>
            </dl>
            
            <dl>
                <dt>Matière</dt>
                <dd>{{compositionData?.course?.name}}</dd>
            </dl>
            <!-- <dl>
                <dt>Période</dt>
                <dd>{{compositionData?.period?.name}}</dd>
            </dl> -->
        </div>
    </div>
 
</div>
</form>

<div class="row mb-5">
    <div class="col-12">
        <div class="d-none d-md-block text-center border" >
            <div class="ag-bg-red  d-flex justify-content-between p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white align-self-center">Apprenant</span>
                <!-- <select class="mx-1" id="" (change)="loadlist($event)">
                    <option selected disabled>Charger la liste des apprenants</option>
                    <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
                </select> -->
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <table class="table table-sm table-striped  table-borderless">
                    <tbody>
                        <tr class="d-flex flex-column flex-md-row row align-items-start no-gutters" *ngFor="let d of data; let i=index">
                            <td class="col-12 col-md-2 ">
                                <p class="text-start"><strong>{{d.lastname}} </strong> {{d.firstname}}</p>
                                <!-- <p class="text-dark h6 text-start"><strong><small>{{d.name}}</small></strong></p> -->

                               <!--  <div class="d-flex">
                                    <img src="assets/avatar.jpg" height="50" width="50" class="img-thumbnail" alt="..."> 
                                    <div class=" align-self-center">
                                        <span class="text-dark h6 text-center"><strong><small>{{d.name}}</small></strong></span>
                                    </div>
                                    </div>-->
                            </td>
                            <td class="col-12 col-md-2">
                                <input type="number" [min]="0" [max]="20" [minlength]="1"  [maxlength]="2" (change)="correctValue($event,i)" (keyUp)="correctValue($event,i)"   name="value" [(ngModel)]="d.value" [readonly]="!d.isSetted" (readonlyChange)="d.isSetted = $event">

                            </td>
                            <td class="col-12 col-md-2">
                                <select name="isSetted" [(ngModel)]="d.isSetted" (change)="resetNote($event,i)">
                                    <option [value]="1">Note disponible</option>
                                    <option [value]="0">Note non disponible</option>
                                </select>
                            </td>
                            <td class="col-12 col-md-4">
                                <div class="col-12 col-md-2" *ngIf="d.isSetted ==0">
                                    <input type="text" name="motif" [(ngModel)]="d.motif" placeholder="Saisir un motif">
                                    <input *ngIf="!d.hasFile" type="file" (change)="upload($event,i)" placeholder="Charger la preuve" (change)="upload($event,i)">
                                    <div class="d-flex flex-column">
                                        <span  *ngIf="d.hasFile" class="text-primary" (click)="open(i)" style="cursor: pointer;"> Voir le fichier</span>
                                        <span *ngIf="d.hasFile" class="text-danger" (click)="remove(i)" style="cursor: pointer;"> Retirer le fichier</span>
                                    </div>
                                </div>
                            </td>
                            <td class="col-12 col-md-2">
                                <input type="text" name="appreciation" [(ngModel)]="d.appreciation" placeholder="Saisir l'appréciation">

                            </td>
                        </tr>
                    </tbody>
                </table>
              
            </div>
        </div>
        <div class="d-block d-md-none text-center border" >
            <div class="ag-bg-red  d-flex justify-content-between p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white align-self-center">Apprenant</span>
                <!-- <select class="mx-1" id="" (change)="loadlist($event)">
                    <option selected disabled>Charger la liste des apprenants</option>
                    <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
                </select> -->
            </div>
            <div class="p-1">
                <table class="table table-sm table-striped  table-borderless">
                    <tbody>
                        <tr class="d-flex flex-column flex-md-row row align-items-start no-gutters" *ngFor="let d of data; let i=index">
                            <td class="col-12 col-md-2 ">
                                <p class="text-start"><strong>{{d.lastname}} </strong> {{d.firstname}}</p>
                                <!-- <p class="text-dark h6 text-start"><strong><small>{{d.name}}</small></strong></p> -->

                               <!--  <div class="d-flex">
                                    <img src="assets/avatar.jpg" height="50" width="50" class="img-thumbnail" alt="..."> 
                                    <div class=" align-self-center">
                                        <span class="text-dark h6 text-center"><strong><small>{{d.name}}</small></strong></span>
                                    </div>
                                    </div>-->
                            </td>
                            <td class="col-12 col-md-2">
                                <input type="number"  [max]="20" [minlength]="1"  [maxlength]="2" (change)="correctValue($event,i)" (keyUp)="correctValue($event,i)"   name="value" [(ngModel)]="d.value" [readonly]="!d.isSetted" (readonlyChange)="d.isSetted = $event">

                            </td>
                            <td class="col-12 col-md-2">
                                <select name="isSetted" [(ngModel)]="d.isSetted" (change)="resetNote($event,i)">
                                    <option [value]="1">Note disponible</option>
                                    <option [value]="0">Note non disponible</option>
                                </select>
                            </td>
                            <td class="col-12 col-md-4">
                                <div class="col-12 col-md-2" *ngIf="d.isSetted ==0">
                                    <input type="text" name="motif" [(ngModel)]="d.motif" placeholder="Saisir un motif">
                                    <input *ngIf="!d.hasFile" type="file" (change)="upload($event,i)" placeholder="Charger la preuve" (change)="upload($event,i)">
                                    <div class="d-flex flex-column">
                                        <span  *ngIf="d.hasFile" class="text-primary" (click)="open(i)" style="cursor: pointer;"> Voir le fichier</span>
                                        <span *ngIf="d.hasFile" class="text-danger" (click)="remove(i)" style="cursor: pointer;"> Retirer le fichier</span>
                                    </div>
                                </div>
                            </td>
                            <td class="col-12 col-md-2">
                                <input type="text" name="appreciation" [(ngModel)]="d.appreciation" placeholder="Saisir l'appréciation">

                            </td>
                        </tr>
                    </tbody>
                </table>
              
            </div>
        </div>
    </div>
</div>

<div class="text-center mb-5">
    <button *ngIf="compositionId==undefined || saveMode" type="button" (click)="store()" class="btn btn-outline-dark" [disabled]="loading || ( !saveMode && composition_id==undefined)"  >Enregistrer les notes <app-loading [isVisible]="loading"></app-loading></button>
    <button *ngIf="compositionId!=undefined" type="button" (click)="update()" class="btn btn-outline-dark" [disabled]="loading"  >Mettre à jour les notes <app-loading [isVisible]="loading"></app-loading></button>
</div>

  <ng-template #contentPDF let-offcanvas>
    <div class="offcanvas-header">
      
      <h4 class="offcanvas-title">Visualiseur de fichier</h4>
      <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
          <ngx-extended-pdf-viewer [src]="pdfSrc"
          style="width: 100%; height: 100%"
          ></ngx-extended-pdf-viewer>
    </div>
  </ng-template>


  <ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="prepareTask(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Vous êtes sur le point d'enregister un devoir.</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" #name ngModel required>
                <span ></span>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la période</label>
                <select class="mx-1 form-control" ngModel name="period">
                    <option selected disabled></option>
                    <option *ngFor="let p of periods" [ngValue]="p">{{p?.name}}</option>
                </select>
            </div>
           
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir le type</label>
                <select class="mx-1 form-control" ngModel name="type">
                    <option selected disabled></option>
                    <option value="Interrogation">Interrogation</option>
                    <option value="Devoir sur table">Devoir sur table</option>
                    <option value="Devoir">Devoir</option>
                </select>
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la classe</label>
                <select class="mx-1 form-control" name="pacc" ngModel  (ngModelChange)="loadCourses($event)" >
                    <option selected disabled></option>
                    <option *ngFor="let pacc of paccs" [ngValue]="pacc">{{pacc?.classroom?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la matière</label>
                <select class="mx-1 form-control" name="course" ngModel (ngModelChange)="loadCompositions1($event)">
                    <option selected disabled></option>
                    <option *ngFor="let c of courses" [ngValue]="c">{{c?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la salle</label>
                <select class="mx-1 form-control" ngModel name="room_id">
                    <option selected disabled></option>
                    <option *ngFor="let room of rooms" [value]="room?.id">{{room?.name}}</option>
                </select>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer maintenant les notes <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>